module.exports = __webpack_public_path__ + "static/media/bkg.58931e91.jpg";